// @flow

export { DisplayMpcreditoInstructions } from './mpcredito-info';
